import * as Blockly from 'blockly/core';
import { blockIcon } from '@/(routers)/boards/editor/block/blockFactory';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = {
    orange: {
        rectColour: CATEGORIES.display.color,
        options: [{ value: 'UPPER_LEFT', label: '左上' }],
    },
    blue: {
        rectColour: CATEGORIES.display.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
} as const;

function applyBoardToPositionField(block: Blockly.Block, board: 'orange' | 'blue'): void {
    const field = block.getField('POSITION') as FieldOperatorDropdown | null;
    if (!field) return;
    field.setOptions([...POSITION_OPTIONS[board].options]);
    if (board === 'orange') field.setValue('UPPER_LEFT');
    (block as Blockly.BlockSvg).render();
}

defineBlock({
    type: 'oled_bar',
    colour: CATEGORIES.display.color,
    tooltip: 'OLEDに棒グラフを表示します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inline: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/oled.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('OLED', { fontSize: 15, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('メーター', 55),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: POSITION_OPTIONS.orange.rectColour,
                    options: [...POSITION_OPTIONS.orange.options],
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'value',
            name: 'VALUE',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'を' }],
        },
        {
            kind: 'value',
            name: 'MIN',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('～', { fontSize: 13, fontWeight: 'medium' }),
                },
            ],
        },
        {
            kind: 'value',
            name: 'MAX',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 1023 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'の範囲で表示する ' }],
        },
    ],
    onInit(this: Blockly.Block) {
        const block = this;
        setTimeout(() => {
            const { useBoardEditorStore } = require('@/stores/useBoardEditorStore');
            const board = useBoardEditorStore.getState().board as 'orange' | 'blue';
            applyBoardToPositionField(block, board);
        }, 0);
    },
    onBoardChange(block: Blockly.Block, board: 'orange' | 'blue') {
        applyBoardToPositionField(block, board);
    },
});
